<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Excel Upload
Author: SDL
Description: Excel Upload Common Component
-->
<template>
  <!-- <div>
    <input type="file" @change="onChange" />
    <button type="button" :class="btnClass" @click="onBeforeUpload">{{ $t(btnLabel) }}</button>
  </div> -->
  <div>
    <label class="btn btn-secondary" for="ex_file">{{ $t(btnLabel) }}</label>
    <input type="file" id="ex_file" @change="onChange" style="display: none;">
  </div>
</template>
<script>
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';

export default {
  name: 'ExcelUpload',
  props: {
    btnLabel: {
      required: false,
      type: String,
      default: 'sdl.common.label.excelUpload',
    },
    btnClass: {
      type: String,
      default: 'btn btn-secondary',
    },
    excelInfo: {
      required: true,
      type: Object,
      default: () => {},
    },
    excelServiceFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    /* beforeClick: {
      type: Function,
      default: () => true,
    }, */
  },
  data() {
    return {
      files: [],
    };
  },
  methods: {
    /**
     * param: event
     * return:
     * exception:
     * Description : Select attachment
     */
    onChange(e) {
      this.files = e.target.files || e.dataTransfer.files;

      const getFileExt = fileName => fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase();
      const extList = 'xls|xlsx'.split('|');

      Object.keys(this.files).forEach(x => {
        if (!extList.includes(getFileExt(this.files[x].name))) {
          SDLUtil.alert(
            SDLUtil.getMsgProp('sdl.common.message.extensionCannotBeAttached', [`${getFileExt(this.files[x].name)}`]),
          );
          this.files = [];
          e.target.value = '';
        }
      });

      if (this.files != null && this.files.length !== 0) {
        this.upload();
      }
    },
    /**
     * param:
     * return:
     * exception:
     * Description : click upload button
     */
    /* onBeforeUpload() {
      if (this.files.length === 0) {
        SDLUtil.alert('sdl.common.message.selectFile');
        return;
      }
      if (!this.beforeClick()) return;

      SDLUtil.confirm({
        msg: 'sdl.common.message.wouldYouLikeUploadExcel',
        // title: 'confirm title',
        // okLabel: 'ok label',
        // cancelLabel: 'Cancel',
        onOkEvt: () => this.upload(),
      });
    }, */
    /**
     * param:
     * return:
     * exception:
     * Description : upload attachment
     */
    upload() {
      this.excelInfo.columnInfoFile = encodeURIComponent(this.excelInfo.columnInfoFile);
      const formData = new FormData();
      formData.append('excelFile', this.files[0]);

      Object.keys(this.excelInfo).forEach(val => {
        if (val === 'param') {
          formData.append(val, JSON.stringify(this.excelInfo[val]));
        } else {
          formData.append(val, this.excelInfo[val]);
        }
      });

      console.log('456456');
      console.log(this.excelServiceFlag);
      console.log(this.excelInfo);
      if (this.excelServiceFlag != null && this.excelServiceFlag === true) {
        console.log('aaa');
        SDLUtil.showLoadingBar(true);
        axios
          .post(`${SDLUtil.API_URL}/excel/service-excel-upload`, formData)
          .then(response => {
            // Loading bar hidden
            SDLUtil.showLoadingBar(false);
            // if (response.data !== '') {
            //   this.$router.push(response.data);
            // }
            console.log('asdsd');
            console.log(response);
            this.$emit('after-upload', response.data);
          })
          .catch(error => {
            SDLUtil.showLoadingBar(false);
            console.log(error);
          });
      } else {
        SDLUtil.showLoadingBar(true);
        axios
          .post(`${SDLUtil.API_URL}/excel/excel-upload`, formData)
          .then(response => {
            // Loading bar hidden
            SDLUtil.showLoadingBar(false);
            // if (response.data !== '') {
            //   this.$router.push(response.data);
            // }
            console.log('asdsd');
            console.log(response);
            this.$emit('after-upload', response.data);
          })
          .catch(error => {
            SDLUtil.showLoadingBar(false);
            console.log(error);
          });
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/common/control/excel/ExcelUpload.vue